import moment from "moment";

import { Badge, CopyButton, CurrencyDisplay } from "../../components";
import { appConfig } from "../../configs";
import {
  IViewTopUp,
  IViewTransaction,
  StatusColors,
} from "../../interfaces-and-types";
import {
  getPaymentStatusIndicator,
  truncateStringWithEllipsis,
} from "../../utils";

export const topUpsDisplayFormatter = (item: IViewTopUp) => {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    getPaymentStatusIndicator(item);

  const topUpSourceName =
    item.bank_trsf_account_name ?? item.source_gateway_merchant_name;
  const topUpSourceAccountNumber =
    item.bank_trsf_account_number ?? item.source_gateway_merchant_id_or_code;
  const topUpSourceBankName =
    item.bank_trsf_bank_name ?? item.source_gateway_code?.toUpperCase();
  const topUpSourceBankCode =
    item.bank_trsf_bank_code ?? item.source_gateway_code;
  const topUpSessionId =
    item.bank_trsf_session_id ?? item.source_gateway_session_id;

  return {
    ...item,
    bank_trsf_account_name: topUpSourceName,
    bank_trsf_account_number: topUpSourceAccountNumber,
    bank_trsf_bank_name: topUpSourceBankName,
    bank_code: topUpSourceBankCode,
    amount: (
      <CurrencyDisplay currencyOrSymbol={item.currency} amount={item.amount} />
    ),
    charged_amount: (
      <CurrencyDisplay
        currencyOrSymbol={item.currency}
        amount={item.charged_amount}
      />
    ),
    payment_type: (
      <strong>{item.payment_type?.split("_").join(" ") || "..."}</strong>
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    description: <strong>{item.description || "..."}</strong>,
    gateway: (
      <img
        src={`${process.env.PUBLIC_URL}/gateway-logos/${item.gateway_code}.svg`}
        alt="gateway logo"
        className="gateway-logo-full"
      />
    ),
    bank_trsf_session_id: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span
            className="transfer-description truncate-text--ellipsis"
            title={topUpSessionId}
          >
            {truncateStringWithEllipsis(topUpSessionId, 8)}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            stringToCopy={topUpSessionId}
            iconDescription="copy bank transfer session id"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    date: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    // more: <OverflowMenuDropDown />,
  };
};
